







import {nextTick} from "process";
import loadShimmer from "./loadShimmer.vue";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
    components: {
        loadShimmer,
    }
})
export default class LoadBar extends Vue {
    @Prop({})perc:number;
}

